
import {
  CLOSE_SUPPLY_SIDEBAR,
  DROP_TEMP_HOVER_BUILDING_LEVEL,
  HIDE_BUILDING_CONFIRM,
  HIDE_BUILD_CONFIRM_DIALOG,
  OPEN_SUPPLY_SIDEBAR,
  SAVE_MAP_POSITION,
  SET_BUILDING_IN_PROGRESS,
  SET_BUILDING_LEVEL,
  SET_HIGHLIGHTED_BUILDING,
  SET_MAP_BLUR,
  SET_MAP_ZOOM,
  SET_SELECTED_BUILDING,
  SET_TEMP_HOVER_BUILDING_LEVEL,
  SHOW_BUILDING_CONFIRM,
  SHOW_BUILD_CONFIRM_DIALOG,
  SYNC_SUPPLY,
  TURN_PHOTO_MODE_OFF,
  TURN_PHOTO_MODE_ON,
  UPDATE_SUPPLY_DATA,
  UPGRADE_BUILDING_ERROR,
  UPDATE_MIN_ZOOM,
  SET_BACKGROUND_URL,
  SHOW_EDGES,
  HIDE_EDGES,
} from "../Actions/ActionSupply";

import { PUSH_PREV_PATH, CLEAR_PREV_PATH } from "../middlewares/prevPathMiddleware";

import { Action } from "../../types/Action";
import { searchToObject } from "../utils/index";

export type IClan = {
  id: number;
  tag: string;
  name: string;
  leveling: number;
  rawDescription: string;
  color: string;
  error: string;
  createdAt: string;
  isDisbanded: boolean;
  personalResource?: number;
  accumulativeResource?: Number;
};

const searchParams = searchToObject();

export const IS_DEV_MODE = Object.keys(searchParams).indexOf('devmode') !== -1 && searchParams.devmode !== false;

const initialZoom = 6;
const initialPosition = [0, 0];
const bounds = [[27, 45], [-27, -45]];

const getBackgroundUrl = (template, host) => {
  if (template && host) {
    return `${host}${template.replace('{building_type}_{level}', 'background').replace('.png', '.jpg')}`;
  }

  return null;
};

const userRolesWithBuildPermission = ['commander', 'executive_officer'];

export type Point = Array<number>;
export type PointArray = Array<Point>;

export type State = {
  isDevMode: boolean;
  prevPathList: Array<string>;
  isMapBlured: boolean;
  initialZoom: number;
  zoom: number;
  position: Point;
  initialMaxBounds: PointArray;
  maxBounds: PointArray;
  buildings: any;
  selectedBuildingId: string | null;
  prevSelectedBuildingId: string | null;
  highlightedBuildingId: string | null;
  prevPosition: PointArray | null;
  highlightDelay: number;
  isPhotoMode: boolean;
  mapHost: string;
  tileUrlTemplate: string | null;
  backgroundUrl: string | null;
  isBuildiDialogVisible: boolean;
  tempHoverBuildingLevel: number | null;
  tempHoverBuildingId: string | null;
  confirmDialogBuildingId: string | null;
  previewLevel: number | null;
  buildingInProgress: string | null;
  isSidebarOpened: boolean;
  confirmBuildingId: string | null;
  hasTooltipConflict: boolean;
  isAchievementsDialogVisible: boolean;
  minZoom: number;
  maxZoom: number;
  hasBuildPermission: boolean;
  edgesVisible: any,
};

let initialState: State = {
  isDevMode: IS_DEV_MODE,
  prevPathList: [],
  isMapBlured: false,
  initialZoom: initialZoom,
  zoom: initialZoom,
  position: initialPosition,
  initialMaxBounds: bounds,
  maxBounds: bounds,
  buildings: null,
  selectedBuildingId: null,
  prevSelectedBuildingId: null,
  highlightedBuildingId: null,
  prevPosition: null,
  highlightDelay: 70,
  isPhotoMode: false,
  mapHost: '',
  tileUrlTemplate: null,
  backgroundUrl: null,

  // buildings
  isBuildiDialogVisible: false,
  tempHoverBuildingLevel: null,
  tempHoverBuildingId: null,
  confirmDialogBuildingId: null,
  previewLevel: null,
  buildingInProgress: null,
  isSidebarOpened: false,
  confirmBuildingId: null,
  hasTooltipConflict: false,
  hasBuildPermission: false,
  isAchievementsDialogVisible: false,
  minZoom: 5,
  maxZoom: 7,
  edgesVisible: {}
};

export type IReducerSupply = (state: State, action: Action) => State;
export const ReducerSupply = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case SHOW_EDGES: {
      const newEdgesVisible = {
        ...state.edgesVisible,
        [action.payload.buildingId]: true
      }
      return {
        ...state,
        edgesVisible: newEdgesVisible
      }
    }
    case HIDE_EDGES: {
      const newEdgesVisible = {
        ...state.edgesVisible,
      }
      if (newEdgesVisible[action.payload.buildingId]) {
        delete newEdgesVisible[action.payload.buildingId]
      }
      return {
        ...state,
        edgesVisible: newEdgesVisible
      }
    }
    case SET_BACKGROUND_URL:
      {
        return {
          ...state,
          backgroundUrl: action.payload.backgroundUrl
        };
      }
    case PUSH_PREV_PATH:
      {
        const newPrevPathList = state.prevPathList.slice();
        newPrevPathList.push(action.payload.pathName);
        return {
          ...state,
          prevPathList: newPrevPathList
        };
      }
    case CLEAR_PREV_PATH:
      {
        return {
          ...state,
          prevPathList: []
        };
      }
    case UPDATE_MIN_ZOOM:
      {
        return {
          ...state,
          minZoom: action.payload.minZoom
        };
      }
    case SHOW_BUILDING_CONFIRM:
      {
        return {
          ...state,
          confirmBuildingId: action.payload.buildingId,
          hasTooltipConflict: true
        };
      }
    case HIDE_BUILDING_CONFIRM:
      {
        return {
          ...state,
          confirmBuildingId: null
        };
      }
    case UPDATE_SUPPLY_DATA:
      {
        return {
          ...state,
          buildings: action.payload.buildings,
          hasBuildPermission: (action.payload.userRole && userRolesWithBuildPermission.indexOf(action.payload.userRole) !== -1) ? true : false,
          mapHost: action.payload.tilingServiceHost,
          tileUrlTemplate: action.payload.tileUrlTemplate,
          backgroundUrl: getBackgroundUrl(action.payload.tileUrlTemplate, action.payload.tilingServiceHost),
          minZoom: action.payload.minZoom,
          maxZoom: action.payload.maxZoom,
          initialZoom: action.payload.minZoom + 1
        };
      }
    case SYNC_SUPPLY:
      {
        return {
          ...state,
          hasBuildPermission: (action.payload.role && userRolesWithBuildPermission.indexOf(action.payload.role) !== -1) ? true : false
        };
      }
    case OPEN_SUPPLY_SIDEBAR:
      {
        return {
          ...state,
          isSidebarOpened: true
        };
      }
    case CLOSE_SUPPLY_SIDEBAR:
      {
        return {
          ...state,
          isSidebarOpened: false
        };
      }
    case UPGRADE_BUILDING_ERROR:
      {
        return {
          ...state,
          buildingInProgress: null
        };
      }
    case SET_BUILDING_IN_PROGRESS:
      {
        return {
          ...state,
          buildingInProgress: action.payload.buildingId
        };
      }
    case SET_TEMP_HOVER_BUILDING_LEVEL:
      {
        return {
          ...state,
          tempHoverBuildingLevel: action.payload.level,
          tempHoverBuildingId: action.payload.buildingId
        };
      }
    case DROP_TEMP_HOVER_BUILDING_LEVEL:
      {
        return {
          ...state,
          tempHoverBuildingLevel: null,
          tempHoverBuildingId: null,
          hasTooltipConflict: false
        };
      }
    case SHOW_BUILD_CONFIRM_DIALOG:
      {
        return {
          ...state,
          isBuildiDialogVisible: true,
          confirmDialogBuildingId: action.payload.buildingId,
          previewLevel: action.payload.previewLevel
        };
      }
    case HIDE_BUILD_CONFIRM_DIALOG:
      {
        return {
          ...state,
          isBuildiDialogVisible: false,
          confirmDialogBuildingId: null,
          previewLevel: null
        };
      }
    case SET_BUILDING_LEVEL:
      {
        let newBuildings = { ...state.buildings };
        if (newBuildings[action.payload.buildingId]) {
          newBuildings[action.payload.buildingId].level = action.payload.level;
        }
        return {
          ...state,
          buildings: newBuildings,
          buildingInProgress: null
        };
      }
    case SET_MAP_ZOOM:
      {
        return {
          ...state,
          zoom: action.payload.zoom
        };
      }
    case TURN_PHOTO_MODE_ON:
      {
        return {
          ...state,
          isPhotoMode: true
        };
      }
    case TURN_PHOTO_MODE_OFF:
      {
        return {
          ...state,
          isPhotoMode: false
        };
      }
    case SAVE_MAP_POSITION:
      {
        return {
          ...state,
          prevPosition: action.payload.bounds
        };
      }
    case SET_MAP_BLUR:
      {
        return {
          ...state,
          isMapBlured: action.payload.isMapBlured
        };
      }
    case SET_SELECTED_BUILDING:
      {
        return {
          ...state,
          selectedBuildingId: action.payload.buildingId,
          prevSelectedBuildingId: action.payload.buildingId ? action.payload.buildingId : state.prevSelectedBuildingId,
          isBuildiDialogVisible: false,
          confirmDialogBuildingId: null,
          previewLevel: null,
          confirmBuildingId: null
        };
      }
    case SET_HIGHLIGHTED_BUILDING:
      {
        return {
          ...state,
          highlightedBuildingId: action.payload.buildingId
        };
      }

    default:
      return state;

  }
};